/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Form, Row, Col, Input, Select, Radio, message, Button } from "antd";
import { contentDiscriptionData } from "../../components/contentDiscriptionData";
import ChildBaggageModal from "./ChildBaggageModal";
import { camelCase } from "../../utils";

import { useDispatch, useSelector } from "react-redux";
import {
  clearBarcode,
  clearPostShipment,
  getChildPacket,
  getServiceAbilityCheckReset,
} from "../../actionsMethods/cashBookingMethods";
const { Option } = Select;

export function CalculaterForm({
  PICKUP_PINCODE,
  result,
  validorNot,
  DELIVERY_PINCODE,
  checkNumbervalue,
  inputHandler,
  serviceAblePincode,
  searchArea,
  AREA,
  disabledOrNot,
  handleOnChange,
  searchData,
  TYPE,
  setCalShow,
  CONTENT,
  DESCRIPTIONS,
  form,
  nonDox,
  statusCode,
  setNonDox,
  setChildLength,
  childLength,
  data,
  allTotal,
  setAllTotal,
}) {
  const dispatch = useDispatch();
  const chidlPacket = useSelector((state) => state.childPacketReducer);
  const { cityData, provinceData } = contentDiscriptionData();
  const [modelState, setModelState] = React.useState(false);
  const [cities, setCities] = React.useState(cityData[provinceData[0]]);
  const [secondCity, setSecondCity] = React.useState(null);
  const [childPacket, setChildPacket] = React.useState(false);
  React.useEffect(() => {
    if (nonDox == false) {
      form.setFieldsValue({
        content: "Document",
      });
      form.setFieldsValue({
        description: null,
      });
    }
  }, [nonDox]);

  React.useEffect(() => {
    form.setFieldsValue({
      noOfChildPacket: chidlPacket.val,
    });
  }, [chidlPacket.val]);

  let veryfiy = form.getFieldValue("noOfChildPacket") == "" ? true : false;

  const handleProvinceChange = (value) => {
    setCities(cityData[value]);
    setSecondCity(cityData[value][0]);
    form.setFieldsValue({
      description: null,
    });
  };
  const onSecondCityChange = (value, event) => {
    setSecondCity(value);
    setCalShow(false);
  };

  const onChangeDoxType = (e) => {
    setCalShow(false);
    dispatch(clearBarcode());
    dispatch(clearPostShipment());
    if (e == "NON-DOX") {
      setNonDox(true);
      form.setFieldsValue({
        content: null,
        description: null,
        weight: null,
        length: null,
        width: null,
        height: null,
        totalVolWeight: null,
        child_Selected: null,
        valueInr: null,
      });
      setChildPacket(false);
    } else {
      setNonDox(false);
      form.setFieldsValue({
        content: "Document",
        weight: null,
        valueInr: null,
      });
    }
  };
  const contentDetails = form.getFieldsValue().content;

  const valumCalculation = (e) => {
    setCalShow(false);
    let length = form.getFieldValue("length");
    let widht = form.getFieldValue("width");
    let height = form.getFieldValue("height");
    let volum = ((+length * +widht * +height) / 5000).toFixed(2);
    form.setFieldsValue({
      totalVolWeight: volum,
    });
  };

  const setFieldsValuesforLWHT = () => {
    form.setFieldsValue({
      height: allTotal?.totalHeight,
      width: allTotal?.totalWidth,
      length: allTotal?.totalLength,
      totalVolWeight: allTotal?.totalOfTotal,
    });
  };

  const scrolltoBottom = (e) => {
    setChildPacket(e.target.value);
    setAllTotal({});

    // scrollTo({
    //   bottom: document.getElementById("bottoId").offsetTop,
    //   left: 0,
    //   behavior: "smooth",
    // });
    document.getElementById("bottoId").scrollIntoView();
  };

  useEffect(() => {
    if (childPacket) {
      document.getElementById("bottoId").scrollIntoView();
    }
  }, [childPacket]);

  const { result: createChildShipmentResult } = useSelector(
    (state) => state.appReducer.getPostShipmentReducer
  );

  const [isDisable, setIsDisable] = useState(false);
  let sm = 24;
  let md = 6;
  return (
    <>
      <Row
        gutter={16}
        style={{
          padding: "20px 80px",
        }}
      >
        <Col md={md} lg={4} sm={sm}>
          <Form.Item
            name="pickupPincode"
            label={
              <span className="calculater-container-pikpin">
                {PICKUP_PINCODE}
              </span>
            }
          >
            <Input
              value={result}
              minLength={6}
              readOnly={true}
              suffix={<div className="green">{statusCode}</div>}
              className="pincodeInput"
            />
            {""}
          </Form.Item>
        </Col>
        <Col md={md} lg={4} sm={sm}>
          <Form.Item
            name="deliveryPincode"
            validateStatus={validorNot?.validateStatus}
            help={validorNot?.errorMsg}
            label={
              <span className="calculater-container-pikpin">
                {" "}
                {DELIVERY_PINCODE}
              </span>
            }
            rules={[
              {
                required: true,
                message: "Please enter value",
                validateTrigger: "onSubmit",
              },
              () => ({
                validator(rule, value = "") {
                  if (value.length > 0 && value.length < 6) {
                    return Promise.reject("Pincode should be 6 digits");
                  } else {
                    return Promise.resolve();
                  }
                },

                validateTrigger: "onSubmit",
              }),
            ]}
            onKeyPress={(event) => {
              if (checkNumbervalue(event)) {
                event.preventDefault();
              }
            }}
          >
            <Input
              className="pincodeInput"
              onChange={inputHandler}
              placeholder="Enter delivery PIN code"
              maxLength={6}
              suffix={
                <div
                  className={
                    serviceAblePincode?.serviceability?.serviceability ===
                    "Regular"
                      ? "green"
                      : serviceAblePincode?.serviceability?.serviceability ===
                        "Premium"
                      ? "orange"
                      : "red"
                  }
                >
                  {serviceAblePincode?.serviceability?.stateCode}
                </div>
              }
            />
          </Form.Item>
        </Col>
        <Col md={md} lg={4} sm={sm}>
          <Form.Item
            name="area"
            className="pincodeType"
            onChange={(e) => searchArea(e.target.value)}
            rules={[
              {
                required: true,
                message: "Please select  value",
              },
            ]}
            label={<span className="calculater-container-pikpin">{AREA}</span>}
          >
            <Select
              showSearch
              className="pincodeType-placecholder"
              placeholder="Search area"
              // disabled={disabledOrNot}
              // onChange={(e) => searchArea(e)}
              onSelect={(value, event) => handleOnChange(value, event)}
            >
              {searchData?.map((option) => (
                <Option
                  key={option?.areaId}
                  value={camelCase(option?.areaName)}
                >
                  {option?.id}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col md={md} lg={4} sm={sm}>
          <Form.Item
            className="pincodeType"
            name="docType"
            label={
              <span className="calculater-container-pikpin"> {TYPE} </span>
            }
          >
            <Select
              className="pincodeType-placecholder"
              placeholder="Select DOX type"
              optionFilterProp="children"
              // disabled={disabledOrNot}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(e) => onChangeDoxType(e)}
              options={[
                {
                  value: "DOX",
                  label: "Dox",
                },
                {
                  value: "NON-DOX",
                  label: "Non-Dox",
                },
              ]}
            ></Select>
          </Form.Item>
        </Col>

        <Col md={md} lg={4} sm={sm}>
          <Form.Item
            className="pincodeType"
            name="content"
            label={
              <span className="calculater-container-pikpin"> {CONTENT} </span>
            }
          >
            <Select
              className="pincodeType-placecholder"
              placeholder="Select a content"
              // disabled={disabledOrNot}
              optionFilterProp="children"
              defaultValue={provinceData[0]}
              onChange={handleProvinceChange}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              options={
                nonDox
                  ? provinceData.map((province) => ({
                      label: province,
                      value: province,
                    }))
                  : [
                      {
                        value: "Document",
                        label: "Document",
                      },
                    ]
              }
            ></Select>
          </Form.Item>
        </Col>
        <Col md={md} lg={4} sm={sm}>
          <Form.Item
            className="pincodeType"
            name="description"
            rules={[
              {
                required: true,
                message: "Please select  value",
              },
            ]}
            label={
              <span className="calculater-container-pikpin">
                {" "}
                {DESCRIPTIONS}{" "}
              </span>
            }
          >
            <Select
              showSearch
              className="pincodeType-placecholder"
              placeholder="Select a description"
              optionFilterProp="children"
              disabled={contentDetails == null || undefined ? true : false}
              filterOption={(input, option) =>
                option.value.toLowerCase().includes(input.toLowerCase())
              }
              onSelect={(value, event) => onSecondCityChange(value, event)}
              value={secondCity}
              options={
                nonDox
                  ? cities?.map((city) => ({
                      label: city,
                      value: city,
                    }))
                  : [
                      {
                        value: "Form, Catalogue & Paper",
                        label: "Form, Catalogue & Paper",
                      },
                      {
                        value: "Passport",
                        label: "Passport",
                      },
                      {
                        value: "Tender Document",
                        label: "Tender Document",
                      },
                    ]
              }
            ></Select>
          </Form.Item>
        </Col>
        {!nonDox ? (
          <>
            <Col md={md} lg={4} sm={sm}>
              <Form.Item
                label={
                  <span className="calculater-container-pikpin">
                    {"Weight(Gms)"}
                  </span>
                }
                name="weight"
                rules={[
                  {
                    required: true,
                    message: "Please enter value",
                  },

                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject();
                      }
                      if (parseInt(value.substring(1, 0)) === 0) {
                        return Promise.reject("Value should not be 0");
                      }
                      if (value < 50) {
                        return Promise.reject(
                          "Weight should be more than 50Gm"
                        );
                      }

                      if (value > 900) {
                        return Promise.reject(
                          "Weight should be less than 900Gm"
                        );
                      }

                      return Promise.resolve();
                    },

                    validateTrigger: "onSubmit",
                  }),
                ]}
                onKeyPress={(event) => {
                  // var invalidChars = ["."];
                  if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                  var invalidChars = ["."];
                  if (invalidChars.includes(event.key)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  className="pincodeInput"
                  placeholder="Enter weight"
                  maxLength={3}
                  // disabled={disabledOrNot}
                  // oninput={(this.value = this.value.replace(/[^0-9]/, ""))}
                  min={1}
                  onChange={() => setCalShow(false)}
                />
              </Form.Item>
            </Col>
            <Col md={md} lg={4} sm={sm}>
              <Form.Item
                name="valueInrDox"
                label={
                  <span className="calculater-container-pikpin">
                    Value (INR)
                  </span>
                }
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter value",
                //   },
                // ]}
                rules={[
                  {
                    required: true,
                    message: "Please enter a value",
                    // validateTrigger: "onSubmit",
                  },
                  {
                    pattern: /^[0-9].*/g,
                    message: "Initial value should be numeric.",
                  },
                  // {
                  //   pattern: /^\d{1,6}(\.\d{0,2})?$/,
                  //   message: "Format should be 000.00",
                  // },
                  () => ({
                    validator(rule, value = "") {
                      if (parseInt(value.substring(1, 0)) === 0) {
                        return Promise.reject("Value should not be 0");
                      } else {
                        return Promise.resolve();
                      }
                    },
                    // validateTrigger: "onSubmit",
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  maxLength={7}
                  className="pincodeInput"
                  // disabled={disabledOrNot}
                  placeholder="Enter value"
                  onChange={() => setCalShow(false)}
                />
              </Form.Item>
            </Col>
          </>
        ) : (
          ""
        )}
        {nonDox ? (
          <>
            {" "}
            <Col md={md} lg={4} sm={sm}>
              <Form.Item
                label={
                  <span className="calculater-container-pikpin">
                    {" "}
                    Weight(Kg)
                  </span>
                }
                name="weight"
                rules={[
                  {
                    required: true,
                    maxLength: 3,
                    message: "Please enter value",
                  },
                  {
                    pattern: /^[0-9]{1,3}(\.[0-9]{1,2})?$/g,
                    message: "Invalid weight",
                  },
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject();
                      }
                      if (parseInt(value.substring(1, 0)) === 0) {
                        return Promise.reject("Value should not be 0");
                      }
                      return Promise.resolve();
                    },

                    validateTrigger: "onSubmit",
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  className="pincodeInput"
                  placeholder="Enter weight"
                  maxLength={6}
                  onChange={(e) => valumCalculation(e)}
                  min={1}
                  // disabled={createChildShipmentResult !== null && true}
                />
              </Form.Item>
            </Col>
            <Col md={md} lg={4} sm={sm}>
              <Form.Item
                label={
                  <span className="calculater-container-pikpin">
                    {" "}
                    Length(Cm)
                  </span>
                }
                name="length"
                rules={[
                  {
                    required: true,
                    message: "Please enter  value",
                  },
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject();
                      }

                      if (value < 1) {
                        return Promise.reject("Length should be more than 1Cm");
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  className="pincodeInput"
                  placeholder="Enter length"
                  maxLength={3}
                  onChange={(e) => valumCalculation(e)}
                  // disabled={createChildShipmentResult !== null && true}
                />
              </Form.Item>
            </Col>
            <Col md={md} lg={4} sm={sm}>
              <Form.Item
                label={
                  <span className="calculater-container-pikpin">
                    {" "}
                    Width(Cm)
                  </span>
                }
                name="width"
                rules={[
                  {
                    required: true,
                    message: "Please enter  value",
                  },
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject();
                      }

                      if (value < 1) {
                        return Promise.reject("Width should be more than 1Cm");
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  className="pincodeInput"
                  placeholder="Enter width"
                  maxLength={3}
                  onChange={(e) => valumCalculation(e)}
                  min={"0"}
                  // disabled={createChildShipmentResult !== null && true}
                />
              </Form.Item>
            </Col>
            <Col md={md} lg={4} sm={sm}>
              <Form.Item
                label={
                  <span className="calculater-container-pikpin">
                    {" "}
                    Height (Cm)
                  </span>
                }
                name="height"
                rules={[
                  {
                    required: true,
                    message: "Please enter value",
                  },
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject();
                      }

                      if (value < 1) {
                        return Promise.reject("Height should be more than 1Cm");
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  className="pincodeInput"
                  placeholder="Enter height"
                  maxLength={3}
                  onChange={(e) => valumCalculation(e)}
                  // disabled={createChildShipmentResult !== null && true}
                />
              </Form.Item>
            </Col>
            <Col md={md} lg={4} sm={sm}>
              <Form.Item
                label={
                  <span className="calculater-container-pikpin">
                    {" "}
                    Vol Weight (Kg)
                  </span>
                }
                name="totalVolWeight"
              >
                <Input
                  className="pincodeInput"
                  readOnly={true}
                  type="number"
                  // disabled={createChildShipmentResult !== null && true}
                />
              </Form.Item>
            </Col>
            <Col md={md} lg={4} sm={sm}>
              <Form.Item
                name="valueInrNonDox"
                label={
                  <span className="calculater-container-pikpin">
                    Value (INR)
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter a value",
                    // validateTrigger: "onSubmit",
                  },
                  {
                    pattern: /^[0-9].*/g,
                    message: "Initial value should be numeric.",
                  },
                  // {
                  //   pattern: /^\d{1,6}(\.\d{0,2})?$/,
                  //   message: "Format should be 000.00",
                  // },
                  () => ({
                    validator(rule, value = "") {
                      if (parseInt(value.substring(1, 0)) === 0) {
                        return Promise.reject("Value should not be 0");
                      } else {
                        return Promise.resolve();
                      }
                    },
                    // validateTrigger: "onSubmit",
                  }),
                ]}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  className="pincodeInput"
                  placeholder="Enter value"
                  maxLength={7}
                  onChange={() => setCalShow(false)}
                  // disabled={createChildShipmentResult !== null && true}
                />
              </Form.Item>
            </Col>
            <Col md={md} lg={4} sm={sm}>
              <Form.Item
                name={"child_Selected"}
                label={
                  <span className="calculater-container-pikpin">
                    Child Packets{" "}
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter value",
                  },
                ]}
                onChange={() => setChildLength(true)}
              >
                <Radio.Group
                  onChange={(e) => scrolltoBottom(e)}
                  className="calculater-container-div-radio"
                  // disabled={createChildShipmentResult !== null && true}
                >
                  <Radio value={true} className="radioButton">
                    Yes
                  </Radio>
                  <Radio value={false} className="radioButton">
                    No
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            {childPacket ? (
              <>
                {" "}
                <Col md={md} lg={4} sm={sm}>
                  <Form.Item
                    label={
                      <span className="calculater-container-pikpin">
                        {" "}
                        No of child packet
                      </span>
                    }
                    name="noOfChildPacket"
                    rules={[
                      {
                        maxLength: 2,
                        message: null,
                      },
                      () => ({
                        validator(_, value) {
                          if (value == 0) {
                            return Promise.reject({
                              message: "value should not be 0",
                            });
                          }
                          return Promise.resolve({});
                        },
                      }),
                    ]}
                    onKeyPress={(event) => {
                      if (checkNumbervalue(event)) {
                        event.preventDefault();
                      }
                    }}
                  >
                    <Input
                      className="pincodeInput"
                      placeholder="Enter no of packets"
                      maxLength={2}
                      // disabled={createChildShipmentResult !== null && true}
                      name="noOfChildPacket"
                      onChange={(e) =>
                        setIsDisable(e.target.value == 0 ? true : false)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col md={md} lg={4} sm={sm} className="button-volum-calculate">
                  <Form.Item
                    label={
                      <span className="calculater-container-pikpin"> </span>
                    }
                    name="chilPackegeButton"
                    disabled={true}
                  >
                    <Button
                      onClick={() => {
                        setModelState(true),
                          dispatch(
                            getChildPacket(
                              form.getFieldValue("noOfChildPacket")
                            )
                          );
                      }}
                      disabled={isDisable}
                      className="button-volum-calculate"
                    >
                      {"Add VOLUMETRIC"}
                    </Button>
                  </Form.Item>
                </Col>
                <Col lg={24}>
                  <ChildBaggageModal
                    visible={modelState}
                    id="bottoId"
                    setCalShow={setCalShow}
                    handleCancel={() => setModelState(false)}
                    setChildLength={setChildLength}
                    numberOfPackets={chidlPacket}
                    allTotal={allTotal}
                    setAllTotal={setAllTotal}
                    form={form}
                    data={data}
                    setFieldsValuesforLWHT={setFieldsValuesforLWHT}
                  />
                </Col>
              </>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}
      </Row>
    </>
  );
}
